// Keep in sync with --z-tour in index.css
export const TOUR_Z_INDEX = 1600;

// Clears the sticky wizard header so scrolled-to targets are not hidden behind it
export const TOUR_SCROLL_OFFSET = 140;

export const TOUR_TARGET_WAIT_MS = 2000;

// Matches the library's own debounce on recomputing the spotlight, so a target
// still in motion is not nudged more often than it can act on
export const TOUR_SPOTLIGHT_SYNC_MS = 100;

// How long a stop's anchor can be gone before the tour moves off it. Long enough
// that a remount inside one render is not mistaken for the anchor being gone
export const TOUR_ANCHOR_RECOVERY_MS = 300;

// How long a break has to be before a finished tour is offered again
export const TOUR_REFRESHER_AFTER_DAYS = 60;

// Every step needs one. The library reads step.placement with no fallback of
// its own and throws on undefined. Auto lets it pick the side that fits.
export const TOUR_DEFAULT_PLACEMENT = "auto";

// The spotlight stays usable so a stop can be carried out as it is explained.
// Everything outside it is inert: a stray click on the dimmed page must not end
// the tour, and escape is off because the library maps it to close, which
// advances a stop rather than exiting. Without skipBeacon the tour waits on a
// beacon click, which reads as nothing having happened.
export const TOUR_OPTIONS = {
   zIndex: TOUR_Z_INDEX,
   scrollOffset: TOUR_SCROLL_OFFSET,
   targetWaitTimeout: TOUR_TARGET_WAIT_MS,
   skipBeacon: true,
   blockTargetInteraction: false,
   overlayClickAction: false,
   dismissKeyAction: false,
};
